import { AreaCalibrationsModel } from './area-calibrations.model';
import { AreaCalibrationsResource } from './area-calibrations.resource';
import { Serializer } from 'src/app/core/common/http/serializer';

export class AreaCalibrationsSerializer implements Serializer {
  fromJson(json: any): AreaCalibrationsResource {
    const resource = new AreaCalibrationsResource();

    resource.id = json.id ?? null;
    resource.links = json.links ?? null;

    resource.commesse = json.commesse;
    resource.site = json.site;
    resource.profile = json.profile;
    resource.type_user = json.type_user;
    resource.notes = json.notes;
    resource.sub_system = json.sub_system;


    resource.phone = json.phone;
    resource.company = json.company;
    resource.stamp_code = json.stamp_code;
    resource.function = json.function;

    return resource;
  }

  toJson(model: AreaCalibrationsModel): any {

    const resource = new AreaCalibrationsResource();
    resource.commesse = [];
    model.commesse.forEach((order) => {
      resource.commesse.push(order.project_name)
    });
    resource.site = model.site;

    if (model.profile && model.profile.length > 0) {
      resource.profile = model.profile[0].description;
    }

    if (model.type_user && model.type_user.length > 0) {
      resource.type_user = model.type_user[0].description;
    }

    if (model.sub_system && model.sub_system.length > 0) {
      resource.sub_system = model.sub_system[0].description;
    }

    resource.phone = model.phone;
    resource.company = model.company;
    resource.stamp_code = model.stamp_code;
    resource.function = model.function;

    resource.notes = model.notes;

    return resource;
  }
}


